const fechaLocal = (valor = new Date()) => {
  const fecha = new Date(valor);
  fecha.setMinutes(fecha.getMinutes() - fecha.getTimezoneOffset());
  return fecha.toISOString().slice(0, 10);
};

export const filtrosNotasCreditoIniciales = (hoy = new Date()) => {
  const hasta = new Date(hoy);
  const desde = new Date(hoy);
  desde.setDate(desde.getDate() - 29);
  return {
    fechaDesde: fechaLocal(desde), fechaHasta: fechaLocal(hasta), clienteId: null,
    pagina: 1, tamanoPagina: 50,
  };
};

export const validarFiltrosNotasCredito = (filtros) => {
  if (!filtros?.fechaDesde || !filtros?.fechaHasta) return "Seleccioná ambas fechas.";
  if (filtros.fechaHasta < filtros.fechaDesde) return "La fecha hasta no puede ser anterior a la fecha desde.";
  const desde = new Date(`${filtros.fechaDesde}T12:00:00`);
  const hasta = new Date(`${filtros.fechaHasta}T12:00:00`);
  if ((hasta - desde) / 86400000 > 366) return "El rango máximo de consulta es de 367 días.";
  const tamano = Number(filtros.tamanoPagina);
  if (!Number.isInteger(tamano) || tamano < 1 || tamano > 200) return "El tamaño de página debe estar entre 1 y 200.";
  return "";
};

export const crearRequestFacturasDisponibles = (empresaId, filtros) => ({
  empresaId: Number(empresaId),
  clienteId: filtros.clienteId ? Number(filtros.clienteId) : null,
  fechaDesde: `${filtros.fechaDesde}T00:00:00`,
  fechaHasta: `${filtros.fechaHasta}T00:00:00`,
  pagina: Math.max(1, Number(filtros.pagina) || 1),
  tamanoPagina: Math.min(200, Math.max(1, Number(filtros.tamanoPagina) || 50)),
});

export const normalizarCantidad = (valor) => {
  if (typeof valor === "number") return valor;
  return Number(String(valor ?? "").replace(",", "."));
};

export const calcularTotalEstimado = (linea, cantidad) => {
  const neto = normalizarCantidad(cantidad) * Number(linea?.precioNeto || 0)
    * (1 - Number(linea?.porcentajeDescuento || 0) / 100);
  return neto + neto * Number(linea?.porcentajeIva || 0) / 100;
};

export const validarBorradorNotaCredito = ({ lineas = [], numeradorId, fecha, motivo }) => {
  const errores = {};
  const seleccionadas = lineas.filter((linea) => linea.seleccionada);
  if (!seleccionadas.length) errores.lineas = "Seleccioná al menos un renglón.";
  if (seleccionadas.length > 200) errores.lineas = "Una nota admite como máximo 200 renglones.";
  const claves = new Set();
  seleccionadas.forEach((linea) => {
    const clave = `${linea.origenDetalle}:${linea.detalleId}`;
    const cantidad = normalizarCantidad(linea.cantidad);
    if (claves.has(clave)) errores.lineas = "No se permiten renglones duplicados.";
    claves.add(clave);
    if (!Number.isFinite(cantidad) || cantidad <= 0) errores[clave] = "Ingresá una cantidad mayor que cero.";
    else if (cantidad > Number(linea.cantidadDisponible)) errores[clave] = "La cantidad supera la disponible.";
  });
  if (!Number(numeradorId)) errores.numeradorId = "Seleccioná un numerador.";
  if (!fecha) errores.fecha = "Ingresá la fecha.";
  const motivoLimpio = String(motivo || "").trim();
  if (!motivoLimpio) errores.motivo = "Ingresá el motivo.";
  else if (motivoLimpio.length > 500) errores.motivo = "El motivo admite hasta 500 caracteres.";
  return errores;
};

export const crearPayloadNotaCredito = ({ empresaId, facturaOrigenId, numeradorId, fecha, motivo, claveIdempotencia, operadorId, pcId, lineas }) => ({
  empresaId: Number(empresaId), facturaOrigenId: Number(facturaOrigenId), numeradorId: Number(numeradorId),
  fecha: fecha.length === 10 ? `${fecha}T12:00:00` : fecha, motivo: String(motivo).trim(), claveIdempotencia,
  operadorId: Number(operadorId), pcId: Number(pcId),
  lineas: lineas.filter((linea) => linea.seleccionada).map((linea) => ({
    origenDetalle: linea.origenDetalle, detalleId: Number(linea.detalleId), cantidad: normalizarCantidad(linea.cantidad),
  })),
});

export const huellaPayloadNotaCredito = (payload) => JSON.stringify({
  facturaOrigenId: payload.facturaOrigenId, numeradorId: payload.numeradorId, fecha: payload.fecha,
  motivo: payload.motivo, lineas: payload.lineas,
});

export const nuevaClaveIdempotencia = () => {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (caracter) => {
    const aleatorio = Math.floor(Math.random() * 16);
    return (caracter === "x" ? aleatorio : (aleatorio & 3) | 8).toString(16);
  });
};

export const resolverClaveIdempotencia = ({ clave, huellaIntentada, huellaActual, generar = nuevaClaveIdempotencia }) =>
  huellaIntentada && huellaIntentada !== huellaActual ? generar() : clave;

export const paginasNotasCredito = (total, tamano) =>
  Math.max(1, Math.ceil((Number(total) || 0) / (Number(tamano) || 50)));
